import * as React from 'react';
// mui
import { Card, CardHeader, Grid } from '@mui/material';
// redux
import { useSelector } from 'react-redux';
import { selectAllEvents, selectUncompleteEvents } from '../../store/selectors/eventSelectors';
import { selectAllRecurringTasks, selectUncompleteRecurringTasks } from '../../store/selectors/recuringTaskSelectors';
import { selectAllTasks, selectUncompleteTasks } from '../../store/selectors/taskSelectors';
// types
import Event from '../../interfaces/Event.interface';
import Task from '../../interfaces/Task.interface';
import RecurringTask from '../../interfaces/RecurringTask.interface';

export default function ItemsCount() {
  const localTasks: Task[] = useSelector(selectAllTasks());
  const localUncompleteTasks: Task[] = useSelector(selectUncompleteTasks());
  const percentageOfTasksCompleted = Math.round((localUncompleteTasks.length / localTasks.length) * 1000) / 10;
  
  const localRecurringTasks: RecurringTask[] = useSelector(selectAllRecurringTasks());
  const localUncompleteRecurringTasks: RecurringTask[] = useSelector(selectUncompleteRecurringTasks());
  const percentageOfRecurringTasksCompleted = Math.round((localUncompleteRecurringTasks.length / localRecurringTasks.length) * 1000) / 10;

  const localEvents: Event[] = useSelector(selectAllEvents());
  const localUncompleteEvents: Event[] = useSelector(selectUncompleteEvents());
  const percentageOfEventsCompleted = Math.round((localUncompleteEvents.length / localEvents.length) * 1000) / 10;

  return (
    <Card sx={{ p: 2, height: '100%' }} variant="outlined">
      <Grid container spacing={1}>
        <Grid size={4}>
          <CardHeader
            title={`Total Tasks: ${localTasks.length}`}
            subheader={`${localUncompleteTasks.length} Uncomplete (${percentageOfTasksCompleted}%)`}
          />
        </Grid>
        <Grid size={4}>
          <CardHeader
            title={`Total Recurring Tasks: ${localRecurringTasks.length}`}
            subheader={`${localUncompleteRecurringTasks.length} Uncomplete (${percentageOfRecurringTasksCompleted}%)`}
          />
        </Grid>
        <Grid size={4}>
          <CardHeader
            title={`Total Events: ${localEvents.length}`}
            subheader={`${localUncompleteEvents.length} Uncomplete (${percentageOfEventsCompleted}%)`}
          />
        </Grid>
      </Grid>
    </Card>
  );
}